import React from "react";
import "./css/loader.scss";

const LoadingDots = (): JSX.Element => (
	<div className="slds-grid slds-grid_align-center ">
		<div className="slds-dots">
			<div className="slds-dots__dot" />
			<div className="slds-dots__dot" />
			<div className="slds-dots__dot" />
		</div>
	</div>
);

export default LoadingDots;
